export default "__VITE_ASSET__Dxz_3v_y__"